/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation SenderRoutePlanCreateMutation($input: [SenderRoutePlanCreateInput!]!) {
  SenderRoutePlanCreate(input: $input) {
    id,
    message,
    status
  }
}
`
